import React from 'react'
import {AuthPage, Window, Form, Input, Resend, PasswordHint} from 'common/components'


export default class Confirm extends AuthPage {
    config = {
        url: 'api/users/password/recovery/confirm',
        method: 'POST',

        namespace: 'confirm',
        typeOf: 'password',
        redirect: '/',

        failure: (status) => (
            status === 'NoAttempts' && '/'
        ),

        sanitize: (data) => ({
            ...data,
            login: {
                login: this.login(),
                loginType: 'phone'
            }
        })
    }

    heading = ['ВІДНОВЛЕННЯ ПАРОЛЯ', '' ]
    login = () => (this.props.match.params.login)


    render() {
        return (
            <div>
                <Window message={this.heading} picture='phone'>
                    <Form
                        label='Підтвердити номер телефону'
                        className='auth__form-adaptive'
                        onSubmit={this.onSubmit}
                        csrf
                    >
                        <Input
                            name='token'
                            type='code'
                            title='Код'
                            validations='isExisty'
                        />

                        <Input
                            name='password'
                            type='password'
                            title='Пароль'
                            validations='isSecure'
                            hint={() => <PasswordHint />}
                        />
                    </Form>

                    <Resend
                        url='api/users/password/recovery/resend'
                        type='phone'
                        login={this.login()}
                        onResponse={this.onResponse}
                    />
                </Window>
            </div>
        )
    }
}
